import { publicRoutes } from './publicRoutes';
import { privateRoutes } from './privateRoutes';
import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import Status404 from 'src/authentications/Status404';

const RoutingHandler = (token)=>{
  return [
    {
      path: '',
      element: token ? <SidebarLayout /> : <BaseLayout />,
      children: token ? [...privateRoutes] : [...publicRoutes]
    },
    {
      path: '*',
      element: <Status404 token={token}  />
    }
  ]
}

export default RoutingHandler;